import { render, staticRenderFns } from "./TenancyApplicationForm.vue?vue&type=template&id=fed87c9c&scoped=true&"
import script from "./TenancyApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./TenancyApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed87c9c",
  null
  
)

export default component.exports